<header class="bg-white shadow-md border-b border-gray-200 py-2">
	<div class="flex items-center justify-between px-6">
		<!-- Logo y nombre -->
		<div class="flex items-center gap-4">
			<a [routerLink]="['/home']" class="flex items-center">
				<img
					priority
					alt="Logo de Extremadura"
					width="610"
					height="920"
					ngSrc="assets/images/logos/junta-ext/Escudo_de_Extremadura.svg"
					class="h-16 w-auto object-contain"
				/>
			</a>
			<span class="text-3xl font-bold text-[#005533] ml-2 hidden sm:inline">Junta de Extremadura</span>
		</div>

		<!-- Botón menú hamburguesa en móvil -->
		<button
			class="sm:hidden flex items-center justify-center p-2 rounded-md border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#005533]"
			(click)="toggleMenu()"
			aria-label="Abrir menú"
		>
			<svg
				class="w-7 h-7 text-[#005533]"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				viewBox="0 0 24 24"
			>
				<path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
			</svg>
		</button>

		<!-- Usuario logueado con menú desplegable (desktop) -->
		<div
			*ngIf="notInLogin() && usuario()"
			class="hidden sm:flex items-center gap-2 mr-10 relative"
			(click)="toggleMenu()"
			tabindex="0"
			(blur)="closeMenu()"
		>
			<div class="flex items-center gap-2 cursor-pointer select-none">
				<img
					[src]="usuario()?.imageUrl || 'assets/images/logos/junta-ext/Escudo_de_Extremadura.svg'"
					alt="Avatar usuario"
					class="w-9 h-9 rounded-full object-cover border border-gray-300 bg-white"
				/>
				<span class="text-base font-medium text-gray-700">{{ usuario()?.username }}</span>
				<!-- Icono de flecha -->
				<svg
					class="w-4 h-4 text-gray-500"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					viewBox="0 0 24 24"
				>
					<path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
				</svg>
			</div>
			<!-- Menú desplegable -->
			<div
				*ngIf="menuAbierto"
				class="absolute left-0 top-full mt-2 w-44 bg-white border border-gray-200 rounded-lg shadow-lg z-50 flex items-center px-3 py-2"
			>
				<button
					(click)="logout()"
					class="flex items-center w-full text-base text-gray-700 hover:bg-gray-100 rounded gap-2"
				>
					<svg
						class="w-5 h-5 text-red-500"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						viewBox="0 0 24 24"
					>
						<path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7" />
						<path stroke-linecap="round" stroke-linejoin="round" d="M7 8v8" />
					</svg>
					Cerrar sesión
				</button>
			</div>
		</div>
	</div>

	<!-- Menú móvil desplegable -->
	<div
		*ngIf="menuAbierto && notInLogin() && usuario()"
		class="sm:hidden absolute top-20 left-0 w-full bg-white border-b border-gray-200 shadow-md z-50"
	>
		<div class="flex flex-col items-center gap-4 py-4">
			<img
				[src]="usuario()?.imageUrl || 'assets/images/logos/junta-ext/Escudo_de_Extremadura.svg'"
				alt="Avatar usuario"
				class="w-16 h-16 rounded-full object-cover border border-gray-300 bg-white"
			/>
			<span class="text-lg font-medium text-gray-700">{{ usuario()?.username }}</span>
			<button
				(click)="logout()"
				class="flex items-center w-40 justify-center text-base text-gray-700 hover:bg-gray-100 rounded gap-2 py-2 border border-gray-200"
			>
				<svg
					class="w-5 h-5 text-red-500"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					viewBox="0 0 24 24"
				>
					<path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7" />
					<path stroke-linecap="round" stroke-linejoin="round" d="M7 8v8" />
				</svg>
				Cerrar sesión
			</button>
		</div>
	</div>
</header>
